import _construct from "@babel/runtime/helpers/construct";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable max-lines */
import { appendScript, mapYBBoxToBBox, mapYCoordsToCoords, mapGeoObjectsToYGeoObjects, getClustersOptions, mapBBoxToYBBox, mapCoordsToYCoords } from '../../utils';
import { YBalloon } from '../YBalloon';
import { YControl } from '../YControl';
import { DEFAULT_DINAMIC_MAP_OPTIONS } from '../../constants/ymap';
import { DEFAULT_GEO_OBJECTS_LOAD_DELAY, DEFAULT_MAX_GEO_OBJECTS_PER_LOAD } from '../../constants';
import { YRouteControl } from '../YRouteControl';
import { CUSTOM_CONTROLS } from '../../constants/customControls';
import { MULTI_ROUTE_CONFIG } from '../../constants/routeControl';

/** Класс-фасад над методами библиотеки яндекс карт */
export var YMap = /*#__PURE__*/function () {
  function YMap(_options) {
    var _this = this;
    _classCallCheck(this, YMap);
    /** Экземпляры классов реализующих внутренние интерфейсы яндекс карт */
    _defineProperty(this, "internal", void 0);
    /** Настройки внутренней реализациии карт */
    _defineProperty(this, "options", void 0);
    /** Метод инициализации карт. Все остальные методы возвращают ошибку,
     *  пока этот метод не вызван и не сработал successCallback */
    _defineProperty(this, "init", function (apiUrl) {
      _this.load({
        require: DEFAULT_DINAMIC_MAP_OPTIONS,
        successCallback: _this.handleSuccessCallback,
        errorCallback: _this.handleErrorCallback
      }, apiUrl);
    });
    /** Добавляет всплывающую подсказку на карту */
    _defineProperty(this, "addBalloon", function (balloon, object) {
      _this.throwInitError();
      new YBalloon().addBalloon({
        balloon: balloon,
        yMap: _this.internal.map,
        yInstance: _this.internal.instance,
        object: object
      });
    });
    /** Добавляет всплывающую подсказку с кастомным контейнером на карту */
    _defineProperty(this, "addBalloonWithContainer", function (balloon, object) {
      _this.throwInitError();
      new YBalloon().addBalloonWithContainer({
        balloon: balloon,
        yMap: _this.internal.map,
        yInstance: _this.internal.instance,
        object: object
      });
    });
    /** Удаляет всплывающую подсказку с карты */
    _defineProperty(this, "removeBalloon", function () {
      _this.throwInitError();
      if (_this.internal.map.balloon && _this.internal.map.balloon.isOpen()) {
        _this.internal.map.balloon.close(true);
      }
    });
    // ----------------------------------------------------------------------------------------------------
    /** Добавляет контролы на карту */
    _defineProperty(this, "addControls", function (controls) {
      _this.throwInitError();
      controls.filter(function (control) {
        return !CUSTOM_CONTROLS.includes(control.type);
      }).forEach(function (control) {
        new YControl().addControl({
          control: control,
          yMap: _this.internal.map,
          yInstance: _this.internal.instance,
          onFullscreenControlClick: _this.onFullscreenControlClick,
          onPanoramaButtonClick: _this.options.onPanoramaButtonClick,
          onPanoramaStateChange: _this.onPanoramaStateChange
        });
      });
    });
    // ----------------------------------------------------------------------------------------------------
    /** Добавляет геообъекты на карту и события для них */
    _defineProperty(this, "addGeoObjects", function (geoObjects) {
      _this.throwInitError();
      if (!geoObjects.length) {
        return;
      }
      var _this$getGeoObjectsBy = _this.getGeoObjectsByMaxGeoObjectsPerLoad(geoObjects),
        resultGeoObjects = _this$getGeoObjectsBy.resultGeoObjects,
        additionalGeoObjects = _this$getGeoObjectsBy.additionalGeoObjects;
      var objectManager = _this.internal.objectManager;
      objectManager.add(mapGeoObjectsToYGeoObjects(_this.internal.instance, resultGeoObjects));

      // добавляем обработчик добавления новых геообъектов из очереди
      objectManager.objects.events.add('optionschange', _this.handleOptionsChange(additionalGeoObjects));
    });
    // ----------------------------------------------------------------------------------------------------
    /** Удаляет геообъекты с карты */
    _defineProperty(this, "removeGeoObjects", function (geoObjects) {
      _this.throwInitError();
      if (!geoObjects.length) {
        return;
      }
      _this.internal.objectManager.remove(geoObjects.map(function (point) {
        return point.options.id;
      }));
    });
    // ----------------------------------------------------------------------------------------------------
    /** Удаляет все геообъекты с карты */
    _defineProperty(this, "removeAllGeoObjects", function () {
      var _this$internal$object;
      _this.throwInitError();
      (_this$internal$object = _this.internal.objectManager) === null || _this$internal$object === void 0 || _this$internal$object.objects.removeAll();
    });
    // ----------------------------------------------------------------------------------------------------
    /** Добавляет мультироут на карту по переданным координатам */
    _defineProperty(this, "addMultiRoute", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(routeId, from, to, routingMode, zoomMargin) {
        var _this$internal$map, _multiRoute$getActive;
        var multiRoute, routesData, routes, wayPointsData, wayPoints;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.throwInitError();
              _context.next = 3;
              return _this.internal.instance.route([[from.coordinates.lng, from.coordinates.lat], [to.coordinates.lng, to.coordinates.lat]], {
                mapStateAutoApply: true,
                routingMode: routingMode,
                multiRoute: true
              });
            case 3:
              multiRoute = _context.sent;
              multiRoute.id = routeId;
              multiRoute.options.set(_objectSpread(_objectSpread({}, MULTI_ROUTE_CONFIG), {}, {
                wayPointVisible: false,
                pinVisible: false,
                routeMarkerIconLayout: null,
                boundsAutoApply: true,
                zoomMargin: zoomMargin
              }));
              (_this$internal$map = _this.internal.map) === null || _this$internal$map === void 0 || _this$internal$map.geoObjects.add(multiRoute);
              if (_this.options.onRouteBuildingSuccess) {
                routesData = multiRoute.getRoutes().toArray();
                routes = routesData.map(function (route) {
                  return route.properties.getAll();
                });
                wayPointsData = multiRoute.getWayPoints().toArray();
                wayPoints = wayPointsData.map(function (point) {
                  return point.properties.getAll();
                });
                _this.options.onRouteBuildingSuccess({
                  mode: routingMode,
                  routes: routes,
                  wayPoints: wayPoints
                });
              }
              return _context.abrupt("return", (_multiRoute$getActive = multiRoute.getActiveRoute()) === null || _multiRoute$getActive === void 0 ? void 0 : _multiRoute$getActive.properties.getAll());
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2, _x3, _x4, _x5) {
        return _ref.apply(this, arguments);
      };
    }());
    // ----------------------------------------------------------------------------------------------------
    /** Принудительно перерисовывает карту чтобы она вписалась в размеры нового
     *  внешнего контейнера(например при ресайзе окна) */
    _defineProperty(this, "redraw", function () {
      _this.throwInitError();
      _this.removeBalloon();
      _this.internal.map.container.fitToViewport();
    });
    // ----------------------------------------------------------------------------------------------------
    /** Устанавливает центр и зум на карте */
    _defineProperty(this, "setCenterAndZoom", function (params) {
      _this.throwInitError();
      var center = params.center,
        zoom = params.zoom,
        duration = params.duration,
        ignoredAreas = params.ignoredAreas;
      var ignoredAreaAccessors;
      if (ignoredAreas) {
        ignoredAreaAccessors = ignoredAreas.map(function (area) {
          return _this.internal.map.margin.addArea(area);
        });
      }
      _this.internal.map.setCenter(center, zoom, {
        duration: duration,
        useMapMargin: true
      });
      if (ignoredAreaAccessors) {
        ignoredAreaAccessors.forEach(function (marginAccessor) {
          return marginAccessor.remove();
        });
      }
    });
    // ----------------------------------------------------------------------------------------------------
    /** Отключение зума при скролле */
    _defineProperty(this, "disableScrollZoom", function () {
      _this.throwInitError();
      _this.internal.map.behaviors.disable('scrollZoom');
    });
    // ----------------------------------------------------------------------------------------------------
    /** Включение зума при скролле */
    _defineProperty(this, "enableScrollZoom", function () {
      _this.throwInitError();
      _this.internal.map.behaviors.enable('scrollZoom');
    });
    // ----------------------------------------------------------------------------------------------------
    /** Состояние зума при скролле */
    _defineProperty(this, "isScrollZoomEnabled", function () {
      _this.throwInitError();
      return _this.internal.map.behaviors.isEnabled('scrollZoom');
    });
    // ----------------------------------------------------------------------------------------------------
    /** Возвращает зум */
    _defineProperty(this, "getZoom", function () {
      var _this$internal$map2;
      return (_this$internal$map2 = _this.internal.map) === null || _this$internal$map2 === void 0 ? void 0 : _this$internal$map2.getZoom();
    });
    /** Устанавливает зум */
    _defineProperty(this, "setZoom", function (zoom) {
      var _this$internal$map3;
      return (_this$internal$map3 = _this.internal.map) === null || _this$internal$map3 === void 0 ? void 0 : _this$internal$map3.setZoom(zoom, {
        duration: 150
      });
    });
    // ----------------------------------------------------------------------------------------------------
    /** Открыть построение маршрута */
    _defineProperty(this, "openRouteControl", function (from, to, routingMode, viewType) {
      _this.throwInitError();
      return _this.internal.routeControl.init(viewType).then(function () {
        if (from) {
          _this.internal.routeControl.setPointFrom(from.coordinates.lat, from.coordinates.lng, !from.fixed, from.label);
        }
        if (to) {
          _this.internal.routeControl.setPointTo(to.coordinates.lat, to.coordinates.lng, !to.fixed, to.label);
        }
        if (routingMode) {
          _this.internal.routeControl.setRoutingMode(routingMode);
        }
      });
    });
    // ----------------------------------------------------------------------------------------------------
    /** Закрыть построение маршрута */
    _defineProperty(this, "closeRouteControl", function () {
      _this.throwInitError();
      _this.internal.routeControl.destroy();
    });
    // ----------------------------------------------------------------------------------------------------
    /** Получить текущую версию карт */
    _defineProperty(this, "getVersion", function () {
      _this.throwInitError();
      return _this.internal.instance.meta.version;
    });
    // ----------------------------------------------------------------------------------------------------
    /** Устанавливает фильтр гео-объектов */
    _defineProperty(this, "filterGeoObjects", function (filter) {
      _this.throwInitError();
      _this.internal.objectManager.setFilter(filter);
    });
    /** Публичный метод принудительного закрытия панорамы */
    _defineProperty(this, "closePanorama", function () {
      _this.throwInitError();
      _this.internal.map.getPanoramaManager().then(function (panoramaManager) {
        return panoramaManager.closePlayer();
      });
    });
    // ----------------------------------------------------------------------------------------------------
    /** Возвращает объект управления линейкой */
    _defineProperty(this, "getRuler", function () {
      var _this$internal$map4;
      return (_this$internal$map4 = _this.internal.map) === null || _this$internal$map4 === void 0 ? void 0 : _this$internal$map4.behaviors.get('ruler');
    });
    // ----------------------------------------------------------------------------------------------------
    /** Возвращает bbox для зоны, ограничивающей видимость карты */
    _defineProperty(this, "getRestrictMapArea", function (restrictMapArea) {
      if (!restrictMapArea) {
        return {};
      }
      return {
        restrictMapArea: mapBBoxToYBBox(restrictMapArea)
      };
    });
    // ----------------------------------------------------------------------------------------------------
    /** Возвращает геообъекты которые должны добавиться на карту сразу и геообъекты которые добавятся через maxGeoObjectsPerLoad */
    _defineProperty(this, "getGeoObjectsByMaxGeoObjectsPerLoad", function (points) {
      var _this$options$maxGeoO = _this.options.maxGeoObjectsPerLoad,
        maxGeoObjectsPerLoad = _this$options$maxGeoO === void 0 ? DEFAULT_MAX_GEO_OBJECTS_PER_LOAD : _this$options$maxGeoO;
      var resultPoints = points;
      var additionalPoints = [];
      if (resultPoints.length > maxGeoObjectsPerLoad) {
        resultPoints = points.slice(0, maxGeoObjectsPerLoad);
        additionalPoints = points.slice(maxGeoObjectsPerLoad);
      }
      return {
        resultGeoObjects: resultPoints,
        additionalGeoObjects: additionalPoints
      };
    });
    // ----------------------------------------------------------------------------------------------------
    /** Агрегирует и возвращает данные для того что бы клиент запросил геообъекты */
    _defineProperty(this, "getGeoObjectsFetchData", function () {
      var state = _this.internal.map.action.getCurrentState();
      var zoom = state.zoom;
      var bounds = _this.internal.map.getBounds();
      var YCenter = _this.internal.map.getCenter();
      var center = mapYCoordsToCoords(YCenter);
      var bbox = mapYBBoxToBBox(bounds);
      return {
        zoom: zoom,
        center: center,
        bbox: bbox
      };
    });
    // ----------------------------------------------------------------------------------------------------
    /** Агрегирует и возвращает настройки для инициализации карты  */
    _defineProperty(this, "getMapData", function () {
      var _this$options = _this.options,
        center = _this$options.center,
        zoomRange = _this$options.zoomRange,
        defaultZoom = _this$options.defaultZoom,
        container = _this$options.container,
        restrictMapArea = _this$options.restrictMapArea;
      return [container.current, {
        center: mapCoordsToYCoords(center),
        zoom: defaultZoom,
        type: 'yandex#map'
      }, _objectSpread(_objectSpread({}, _this.getRestrictMapArea(restrictMapArea)), {}, {
        minZoom: zoomRange.min,
        maxZoom: zoomRange.max,
        searchControlProvider: 'yandex#search'
      })];
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработка окончания изменения/перемещения карты, вызов колбека */
    _defineProperty(this, "handleActionEnd", function () {
      _this.options.onActionEnd(_this.getGeoObjectsFetchData());
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработка изменения статуса полноэкранного режима */
    _defineProperty(this, "onFullscreenControlClick", function (state) {
      if (state) {
        _this.handleFullscreenEnter();
      } else {
        _this.handleFullscreenExit();
      }
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработка изменения статуса полноэкранного режима */
    _defineProperty(this, "onPanoramaStateChange", function (status) {
      _this.options.onPanoramaStateChange(status);
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработка выхода из полноэкранного режима */
    _defineProperty(this, "handleFullscreenExit", function () {
      if (_this.options.disableScrollZoom) {
        _this.disableScrollZoom();
      }
      _this.options.onFullscreenStateChange(false);
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработка входа в полноэкранный режим */
    _defineProperty(this, "handleFullscreenEnter", function () {
      if (!_this.isScrollZoomEnabled()) {
        _this.enableScrollZoom();
      }
      _this.options.onFullscreenStateChange(true);
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработка изменения/перемещения карты, вызов колбека */
    _defineProperty(this, "handleActionTick", function () {
      if (!_this.options.onMove) {
        return;
      }
      _this.options.onMove(_this.getGeoObjectsFetchData());
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработка успешной загрузки карты, вызов successCallback, добавление слушателей событий на карту */
    _defineProperty(this, "handleSuccessCallback", function (instance) {
      _this.internal.instance = instance;
      require('../../vendor/round');
      var map = _construct(instance.Map, _toConsumableArray(_this.getMapData()));
      _this.internal.map = map;
      _this.handleActionEnd();
      map.events.add('actionend', _this.handleActionEnd);
      map.events.add('actiontick', _this.handleActionTick);
      var yClustersOptions = getClustersOptions(_this.options.clustersOptions);
      var objectManager = new instance.ObjectManager(yClustersOptions);
      _this.internal.objectManager = objectManager;
      map.geoObjects.add(objectManager);
      objectManager.objects.events.add('click', _this.handleGeoObjectClick(objectManager));
      var balloon = _this.internal.map.balloon;
      balloon.events.add('open', _this.handleBalloonOpen(balloon));
      balloon.events.add('userclose', _this.handleBalloonClose(balloon));
      var routeControl = new YRouteControl(map, instance, {
        onActiveRouteChange: _this.options.onActiveRouteChange,
        onRoutesUpdate: _this.options.onRouteBuildingSuccess,
        onRequestSend: _this.options.onRouteBuildingInit,
        onInit: _this.options.onRoutingStart,
        onDestroy: _this.options.onRoutingEnd
      });
      _this.internal.routeControl = routeControl;
      _this.options.successCallback();
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработка добавления новых пинов из очереди пинов */
    _defineProperty(this, "handleOptionsChange", function (points) {
      return function () {
        var _this$options$geoObje = _this.options.geoObjectsLoadDelay,
          geoObjectsLoadDelay = _this$options$geoObje === void 0 ? DEFAULT_GEO_OBJECTS_LOAD_DELAY : _this$options$geoObje;
        setTimeout(function () {
          return _this.addGeoObjects(points);
        }, geoObjectsLoadDelay);
      };
    });
    // ----------------------------------------------------------------------------------------------------
    /** Вызов колбека при ошибке */
    _defineProperty(this, "handleErrorCallback", function () {
      _this.options.errorCallback();
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработка клика по геообъекту, вызов колбека */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _defineProperty(this, "handleGeoObjectClick", function (objectManager) {
      return /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
          var objectId, _objectManager$object, geometry, options, properties, geoObject;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                objectId = e.get('objectId');
                _objectManager$object = objectManager.objects.getById(objectId), geometry = _objectManager$object.geometry, options = _objectManager$object.options, properties = _objectManager$object.properties;
                geoObject = {
                  type: geometry.type,
                  name: properties.name,
                  options: properties.options
                }; // Оставляю тут способ получать html pointa
                // const pointId = getMapPointId(object.id); const element = document.getElementById(pointId);
                _context2.t0 = geometry.type;
                _context2.next = _context2.t0 === 'Point' ? 6 : _context2.t0 === 'LineString' ? 8 : _context2.t0 === 'Polygon' ? 10 : 10;
                break;
              case 6:
                _this.options.onGeoObjectClick(geoObject, {
                  offset: [0, options.iconOffset[1]],
                  coordinates: geometry.coordinates
                });
                return _context2.abrupt("break", 11);
              case 8:
                _this.options.onGeoObjectClick(geoObject, {
                  offset: [0, -8],
                  coordinates: e.get('coords')
                });
                return _context2.abrupt("break", 11);
              case 10:
                return _context2.abrupt("return");
              case 11:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x6) {
          return _ref2.apply(this, arguments);
        };
      }();
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработка открытия балуна, вызов колбека */
    _defineProperty(this, "handleBalloonOpen", function (balloon) {
      return function () {
        var objectManager = _this.internal.objectManager;
        var options = balloon.getOptions();
        var objectId = options.get('targetObjectId');
        var _objectManager$object2 = objectManager.objects.getById(objectId),
          geometry = _objectManager$object2.geometry,
          properties = _objectManager$object2.properties;
        var onBalloonOpen = _this.options.onBalloonOpen;
        if (onBalloonOpen) {
          onBalloonOpen({
            type: geometry.type,
            name: properties.name,
            options: properties.options
          });
        }
      };
    });
    // ----------------------------------------------------------------------------------------------------
    /** Обработка закрытия балуна */
    _defineProperty(this, "handleBalloonClose", function (balloon) {
      return function () {
        var onBalloonClose = _this.options.onBalloonClose;
        var options = balloon.getOptions();
        var objectManager = _this.internal.objectManager;
        var objectId = options.get('targetObjectId');
        if (objectId && onBalloonClose) {
          var _objectManager$object3 = objectManager.objects.getById(objectId),
            geometry = _objectManager$object3.geometry,
            properties = _objectManager$object3.properties;
          onBalloonClose({
            type: geometry.type,
            name: properties.name,
            options: properties.options
          });
        }
      };
    });
    // ----------------------------------------------------------------------------------------------------
    /** Возвращает ошибку если карта не инициализирована (сработал successCallback)*/
    _defineProperty(this, "throwInitError", function () {
      if (!_this.internal.map) {
        throw new Error('Карта не инициализирована! Необходимо вызвать метод init');
      }
    });
    // ----------------------------------------------------------------------------------------------------
    /** Загрузка яндекс карт путем вставки скрипта с необходимым урлом в DOM */
    _defineProperty(this, "load", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(options, apiUrl) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!_this.internal.ymapsPromise) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return", _this.internal.ymapsPromise);
            case 2:
              if (!window.ymaps) {
                _context3.next = 5;
                break;
              }
              if (options.require && options.require.length) {
                window.ymaps.modules.require(options.require, function () {
                  _this.handleSuccessCallback(window.ymaps);
                });
              }
              return _context3.abrupt("return", Promise.resolve(window.ymaps));
            case 5:
              _this.internal.ymapsPromise = new Promise(function (resolve, reject) {
                appendScript({
                  apiUrl: apiUrl,
                  onload: function onload() {
                    resolve(window.ymaps);
                  },
                  onerror: function onerror() {
                    options.errorCallback();
                    reject(new Error('Невозможно загрузить Yandex Maps API'));
                  }
                });
              });
              return _context3.abrupt("return", _this.internal.ymapsPromise.then(function (ymaps) {
                return ymaps.ready(options);
              }));
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x7, _x8) {
        return _ref3.apply(this, arguments);
      };
    }());
    this.options = _options;
    this.internal = {};
  }
  return _createClass(YMap, [{
    key: "removeMultiRoute",
    value: /** Удаляет маршрут с карты по его идентификатору */
    function removeMultiRoute(routeId) {
      var _this$internal$map5,
        _this2 = this;
      this.throwInitError();
      if ((_this$internal$map5 = this.internal.map) !== null && _this$internal$map5 !== void 0 && _this$internal$map5.geoObjects) {
        var _this$internal$map6;
        (_this$internal$map6 = this.internal.map) === null || _this$internal$map6 === void 0 || _this$internal$map6.geoObjects.each(function (geoObject) {
          if ('id' in geoObject && geoObject.id === routeId) {
            var _this2$internal$map;
            (_this2$internal$map = _this2.internal.map) === null || _this2$internal$map === void 0 || _this2$internal$map.geoObjects.remove(geoObject);
          }
        });
      }
    }
  }]);
}();